var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 220,
    height: 97,
    viewBox: "0 0 220 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7682 0.0167243C54.8978 0.0167243 62.0274 1.45147 68.444 4.32095V91.1229C62.0274 94.7097 54.8978 96.1445 47.7682 96.1445C21.3888 96.1445 0 74.6233 0 48.0806C0 21.5379 21.3888 0.0167243 47.7682 0.0167243Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1199 17.9517V84.6672C85.26 84.3804 86.243 84.0712 87.2117 83.7664C88.6661 83.3088 90.0885 82.8614 91.9625 82.5151C96.3528 81.7039 98.9198 81.4477 103.37 81.7977C108.217 82.1791 115.49 84.6672 115.49 84.6672L118.342 86.102C118.342 86.102 118.858 86.3005 119.055 86.102C119.251 85.9037 119.055 85.3846 119.055 85.3846C119.055 85.3846 118.342 83.2325 117.629 82.5151L84.1199 17.9517Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.214 5.00079C155.723 2.15308 162.955 0.0172904 170.911 0.0172904C197.671 -0.694639 219.368 20.6632 219.368 48.4285C219.368 74.7699 197.671 96.1277 170.911 96.1277C162.955 96.1277 155.723 93.992 149.214 91.1442V5.00079Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.176 59.1088C123.176 59.1088 132.578 75.4832 133.301 76.907C134.024 12.1213 133.999 10 133.999 10C133.999 10 128.023 12.8626 123.899 13.5453C119.998 14.1911 117.39 14.2572 113.773 13.5453C110.157 12.8334 106.541 12.1214 102.925 10.6976L99.3085 9.27373C98.2573 8.86089 97.8675 8.67064 97.8043 8.74597C97.7637 8.79428 97.8574 8.95186 97.9971 9.23004C97.9971 9.23004 99.3085 12.1215 100.032 13.5453C107.264 28.4958 115.22 44.1583 123.176 59.1088Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 209.42,
    y1: 83.4713,
    x2: 4.93056,
    y2: 21.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#347760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#76B969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 209.42,
    y1: 83.4713,
    x2: 4.93056,
    y2: 21.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#347760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#76B969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 209.42,
    y1: 83.4713,
    x2: 4.93056,
    y2: 21.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#347760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#76B969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 209.42,
    y1: 83.4713,
    x2: 4.93056,
    y2: 21.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#347760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#76B969"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.d02ad6c2.svg";
export { ForwardRef as ReactComponent };